import { styled } from "styled-components";

export const CallRatesCostsSectionWrapper = styled.div<{ $inverted?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, $inverted }) =>
          $inverted ? theme.colors.default[50] : undefined};
  padding: 64px 0;
`;

export const CallRatesCostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  padding: 64px 24px;
  gap: 64px;
  width: 100%;
`;

export const CostCardsContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
  }
`;
export const InternationalCostsContainer = styled.div`
  max-height: 4420px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.lg.query} {
    max-height: 6600px;
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    max-height: 100%;
  }
`;

export const IntlCostCardGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 12px;

  ${({ theme }) => theme.breakpoints.lg.query} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    grid-template-columns: [first] 100%;
  }
`;

export const IntlCostCardColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  background: ${({ theme }) => theme.colors.base};
  height: 100%;
`;
